module.exports = __webpack_public_path__ + "static/media/Tech_BG.e755909b.jpg";